import _ from 'lodash'

import i18n from '@/i18n/i18n'
import SupplierVehicleService from '@/services/admin/SupplierVehicleService'
import { errorMessage } from '@/utilities/helpers.js'

import { SUPPLIER_VEHICLE_ERROR_MESSAGES } from '@/constants/errorMessages'

const { t } = i18n.global

export const allowedFilters = []
export const allowedIncludes = ''
export const allowedSorts = ''
export const allowedAppends = ''

export const namespaced = true

export const state = {
  vehicles: []
}
export const mutations = {
  SET_SUPPLIER_VEHICLES(state, suppliers) {
    state.vehicles = suppliers.data
  },
  ADD_SUPPLIER_VEHICLE(state, supplier) {
    state.vehicles.push(supplier)
  },
  UPDATE_SUPPLIER_VEHICLE(state, supplierVehicle) {
    let index = _.findIndex(state.vehicles, function (s) {
      return s.id === supplierVehicle.id
    })

    if (index !== -1) {
      state.vehicles[index] = supplierVehicle
    }
  },
  DELETE_SUPPLIER_VEHICLE(state, deletedSupplier) {
    state.vehicles = state.vehicles.filter(supplier => {
      return supplier.id !== deletedSupplier.id
    })
  }
}

export const actions = {
  getSupplierVehicles({ commit, dispatch }, supplier) {
    return new Promise((resolve, reject) => {
      SupplierVehicleService.getSupplierVehicles(supplier.id)
        .then(response => {
          commit('SET_SUPPLIER_VEHICLES', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: SUPPLIER_VEHICLE_ERROR_MESSAGES.getSupplierVehiclesError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  createSupplierVehicle({ dispatch, commit, state }, data) {
    return new Promise((resolve, reject) => {
      SupplierVehicleService.createSupplierVehicle(data.supplier_id, data)
        .then(response => {
          commit('ADD_SUPPLIER_VEHICLE', response.data)

          const notification = {
            type: 'success',
            message: t('store.shared.added', {
              element: t('store.admin.supplier_vehicles.supplier_vehicle')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: SUPPLIER_VEHICLE_ERROR_MESSAGES.createSupplierVehicleError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  editSupplierVehicle({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      SupplierVehicleService.editSupplierVehicle(data.supplier_id, data.id, data)
        .then(response => {
          commit('UPDATE_SUPPLIER_VEHICLE', response.data)

          const notification = {
            type: 'success',
            message: t('store.shared.updated', {
              element: t('store.admin.supplier_vehicles.supplier_vehicle')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: SUPPLIER_VEHICLE_ERROR_MESSAGES.editSupplierVehicleError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  deleteSupplierVehicle({ dispatch, commit }, data) {
    return new Promise((resolve, reject) => {
      SupplierVehicleService.deleteSupplierVehicle(data.supplier_id, data.id)
        .then(response => {
          commit('DELETE_SUPPLIER_VEHICLE', response.data)

          const notification = {
            type: 'success',
            message: t('store.shared.deleted', {
              element: t('store.admin.supplier_vehicles.supplier_vehicle')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: SUPPLIER_VEHICLE_ERROR_MESSAGES.deleteSupplierVehicleError + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
